import { render, staticRenderFns } from "./ActionLevelSettings.vue?vue&type=template&id=364fbbba&scoped=true&"
import script from "./ActionLevelSettings.vue?vue&type=script&lang=js&"
export * from "./ActionLevelSettings.vue?vue&type=script&lang=js&"
import style0 from "./ActionLevelSettings.vue?vue&type=style&index=0&id=364fbbba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364fbbba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('364fbbba')) {
      api.createRecord('364fbbba', component.options)
    } else {
      api.reload('364fbbba', component.options)
    }
    module.hot.accept("./ActionLevelSettings.vue?vue&type=template&id=364fbbba&scoped=true&", function () {
      api.rerender('364fbbba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/CustomActions/ActionLevelSettings.vue"
export default component.exports